<app-report reportId="RetrainingDashboard" screen="RETGSD" [submenu]="true"></app-report>
